<template>
    <div 
        id="press"
    >
        <p>{{pressText}}</p>
    </div>
</template>

<script>
    export default {  
        name: 'Press', 
        data: () => ({
            pressText: 'Want to know more exciting news and updates from Youth Opportunities? YO Press will keep you posted on recent successes, projects and programs for your convenience.'
        })
    }
</script> 